import React, { useCallback } from "react";
import styles from "./Page404.module.scss";
import Button from "@material-ui/core/Button";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useHistory } from "react-router";

const useStyle = makeStyles((theme: Theme) => ({
  btn: {
    zIndex: 3,
    backgroundColor: "#2699fb",
    marginTop: 20,
  },
}));

const Page404 = () => {
  const classes = useStyle();
  const history = useHistory();

  const goLogin = useCallback(() => {
    history.push("/login");
  }, [history]);
  return (
    <div className={styles.container}>
      <div className={styles.hero}></div>
      <div className={styles.main}>
        <div>
          <h1>404</h1>
        </div>
        <h2>Oops! Page Not Found</h2>
        <Button
          variant="contained"
          color="primary"
          className={classes.btn}
          onClick={goLogin}
        >
          ログイン画面へ
        </Button>
      </div>
    </div>
  );
};

export default Page404;
